import React from 'react';
import { TagV2Size } from '@zola/zola-ui/src/components/Tag/TagV2';

import { BannerText, BannerWrapper, StyledLink, StyledTag } from './Banner.styles';
import { getTagColor } from '../utils';

export type BannerProps = {
  banner: {
    message: string;
    color: string;
    backgroundColor: string;
    cta: string;
    ctaLink: string;
    label?: string;
  };
  isLeftAligned: boolean;
};

export const Banner = (props: BannerProps): JSX.Element => {
  const { banner, isLeftAligned } = props;

  const { message, color, cta, ctaLink, label } = banner;
  return (
    <BannerWrapper isLeftAligned={isLeftAligned}>
      {label && (
        <StyledTag size={TagV2Size.SMALL} variant={getTagColor(color)}>
          {label}
        </StyledTag>
      )}
      <BannerText color={color}>{message}</BannerText>
      {cta && ctaLink && (
        <StyledLink noTextTransform textcolor={color} href={ctaLink}>
          {cta}
        </StyledLink>
      )}
    </BannerWrapper>
  );
};
